import { render, staticRenderFns } from "./noticePlatform.vue?vue&type=template&id=1a3943d7&scoped=true&"
import script from "./noticePlatform.vue?vue&type=script&lang=js&"
export * from "./noticePlatform.vue?vue&type=script&lang=js&"
import style0 from "./noticePlatform.vue?vue&type=style&index=0&id=1a3943d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3943d7",
  null
  
)

export default component.exports